// extracted by mini-css-extract-plugin
module.exports = {"content":"SectorsStep_content__3Pbii","sectorsContainer":"SectorsStep_sectorsContainer__1kiSK"};